<div class="ai-config-container">
  <!-- Header -->
  <div class="section-header">
    <div class="header-content">
      <h2>AI Configuration</h2>
      <p class="section-description">Configure AI models and provide API credentials for AI inference</p>
    </div>
  </div>

  <!-- Messages -->
  <div class="message error-message" *ngIf="errorMessage">
    <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
  </div>
  <div class="message success-message" *ngIf="successMessage">
    <i class="fas fa-check-circle"></i> {{ successMessage }}
  </div>

  <!-- Loading State -->
  <div class="loading-container" *ngIf="isLoading">
    <i class="fas fa-spinner fa-spin"></i> Loading AI configuration...
  </div>

  <!-- Main Content -->
  <div class="content-grid" *ngIf="!isLoading && selectedOrganization">

    <!-- AI Configurations Section -->
    <section class="config-section">
      <div class="section-title">
        <h3><i class="fas fa-cog"></i> AI Configuration</h3>
        <p>Select which AI configuration this organization should use</p>
      </div>

      <div class="config-list">
        <div
          *ngFor="let display of aiConfigurations"
          class="config-card card"
          [class.selected]="display.isSelected"
        >
          <div class="config-header">
            <div class="config-info">
              <h4>{{ display.config.Name }}</h4>
              <p *ngIf="display.config.Description">{{ display.config.Description }}</p>
            </div>
            <div class="config-status">
              <span class="status-badge status-active" *ngIf="display.isSelected">
                <i class="fas fa-check"></i> Active
              </span>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="config-actions">
            <button
              *ngIf="!display.isSelected"
              class="btn btn-primary"
              (click)="selectConfiguration(display)"
              [disabled]="isSaving"
            >
              <i class="fas fa-check"></i> Use This Configuration
            </button>
            <button
              *ngIf="display.isSelected"
              class="btn btn-secondary"
              (click)="clearConfiguration()"
              [disabled]="isSaving"
            >
              <i class="fas fa-times"></i> Clear Selection
            </button>
          </div>
        </div>

        <!-- No Configurations -->
        <div class="empty-state card" *ngIf="aiConfigurations.length === 0">
          <i class="fas fa-robot"></i>
          <p>No AI configurations available</p>
          <p class="empty-hint">Contact your administrator to set up AI configurations</p>
        </div>
      </div>
    </section>

    <!-- Credentials Section -->
    <section class="credentials-section">
      <div class="section-title">
        <h3><i class="fas fa-key"></i> AI Credentials</h3>
        <p>API keys for AI inference providers. Add or change keys in the Credentials section.</p>
      </div>

      <!-- Credentials List -->
      <div class="credentials-list">
        <div *ngFor="let cred of aiVendorCredentials" class="credential-card card">
          <div class="credential-header">
            <div class="credential-icon">
              <i class="fas fa-key"></i>
            </div>
            <div class="credential-info">
              <h4>{{ displayName(cred.Name) }}</h4>
              <span class="status-badge" [ngClass]="cred.Status === 'Active' ? 'status-active' : 'status-inactive'">
                {{ cred.Status }}
              </span>
            </div>
          </div>
          <div class="credential-meta" *ngIf="cred.CredentialNotes">
            <p>{{ cred.CredentialNotes }}</p>
          </div>
          <div class="credential-footer">
            <span class="last-used" *ngIf="cred.LastUsedAt">
              <i class="fas fa-clock"></i> Last used {{ cred.LastUsedAt | date:'short' }}
            </span>
            <button class="btn btn-icon btn-danger" title="Delete" (click)="deleteCredential(cred)" [disabled]="isSaving">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>

        <!-- No Credentials -->
        <div class="empty-state card" *ngIf="aiVendorCredentials.length === 0">
          <i class="fas fa-key"></i>
          <p>No AI credentials configured</p>
          <p class="empty-hint">Add an "AI Vendor API Key" in the Credentials section to enable AI functionality</p>
        </div>
      </div>
    </section>
  </div>
</div>
